import { getField, updateField } from 'vuex-map-fields';
import axios from 'axios';

const state = () => ({
    estimatedAnnualCharge: 12300,
    paymentType: null,
    waterPaymentVAT: null,
    paymentAuthorisation: null,
    termsAcceptance: null,
    receiveInformation: null,
    receiveInformationType: [],
    paymentTerm: 'monthly',
    paymentDate: null,
    paymentAccountName: null,
    paymentAccountNumber: null,
    sortcode1: null,
    sortcode2: null,
    sortcode3: null,
    bankVerificationStatus: null,
})
 
const getters = {
    getField,
}

const actions = {
    fetchSigningUrl({ commit, state, rootState }) {
        return new Promise((resolve, reject) => {
            const key = rootState.informationStep.key;

            const url = `/quotetoolapi/contract/getdocusigncontractforsigning`;
            // Docusign integration 
            let docusignPayload = {
                key,
                paymentType: state.paymentType,
                ddPaymentTerm: 'monthly',
                ddPaymentDate: null,
                ddAccountHolder: null,
                ddAccountNumber: null,
                ddSortcode: null,
                vatOnWaterBills: state.waterPaymentVAT,
                hasAcceptedTerms: state.termsAcceptance,
                wantsToReceiveMoreInfo: state.receiveInformation, 
                moreInfoPreferredCommunication: state.receiveInformationType,
            };

            if (state.paymentType == 'DD') {
                docusignPayload = Object.assign({}, docusignPayload, {
                    ddPaymentTerm: state.paymentTerm,
                    ddPaymentDate: state.paymentDate,
                    ddAccountHolder: state.paymentAccountName,
                    ddAccountNumber: String(state.paymentAccountNumber),
                    ddSortcode: `${state.sortcode1}-${state.sortcode2}-${state.sortcode3}`,
                })
            }

            axios.post(url, docusignPayload)
                .then(response => {
                    resolve(response.data.url)
                })
                .catch(error => {
                    reject(error);
                })
        });

    },

    /**
     * Initiates bank verification process
     * */
    getBankVerification({ commit, state }) {
        return new Promise((resolve, reject) => {
            const url = `/quotetoolapi/contract/getbankverification`;
             
            axios.get(url, {
                params: {
                    accountNumber: state.paymentAccountNumber, 
                    sortCode: `${state.sortcode1}-${state.sortcode2}-${state.sortcode3}`,
                }
            }).then(response => {
                const { data } = response;
                commit('updateBankVerificationStatus', data.valid);
                resolve(data.valid);
            }).catch(error => {
                reject(error);
            })
        })
    }
}

const mutations = {
    updateField,

    updateBankVerificationStatus(state, status) {
        state.bankVerificationStatus = status;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}